import { getUserInfo, register } from './asyncThunks';

export const registerBuilder = builder => {
  builder.addCase(register.pending, state => {
    state.pending.register = true;
  });
  builder.addCase(register.fulfilled, state => {
    state.pending.register = false;
  });
  builder.addCase(register.rejected, state => {
    state.pending.register = false;
  });
};

export const getUserInfoBuilder = builder => {
  builder.addCase(getUserInfo.pending, state => {
    state.pending.getUserInfo = true;
  });
  builder.addCase(getUserInfo.fulfilled, state => {
    state.isLoggedIn = true;
    state.pending.getUserInfo = false;
  });
  builder.addCase(getUserInfo.rejected, state => {
    state.isLoggedIn = false;
    state.pending.getUserInfo = false;
  });
};
